import { api } from "../api/Middleware";
import { CHATS_URL, WABOTTY_URL } from "../api/Urls";

const ChatService = {
  getAccount: async (token) => {
    try {
      const response = await api.get(
        WABOTTY_URL + `get_accounts/?b_token=${token}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching account:", error);
      throw error;
    }
  },

  getChats: async (uid, offset = 0, limit = 10) => {
    const params = { uid, limit, offset };

    const response = await api.get(CHATS_URL, { params });
    return response.data;
  },

  getChatMessages: async (uid, phone, before = null, limit = 30) => {
    try {
      const params = { uid, limit };
      if (before) params.before = before;

      const response = await api.get(CHATS_URL + `${phone}/messages/`, {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching chat messages:", error);
      throw error;
    }
  },

  // RF03 – Envio de mensagem via REST (fallback)
  sendMessage: async (data) => {
    try {
      const response = await api.post(CHATS_URL + "messages/send/", data);
      return response.data;
    } catch (error) {
      console.error("Error sending message:", error);
      throw error;
    }
  },
};

export default ChatService;